'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = require('react-i18next');

var _PopoverMenuItem = require('components/PopoverMenu/PopoverMenuItem');

var _PopoverMenuItem2 = _interopRequireDefault(_PopoverMenuItem);

var _PopoverMenu = require('components/PopoverMenu/PopoverMenu');

var _PopoverMenu2 = _interopRequireDefault(_PopoverMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MyPlaylistTrackPopover = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_temp = _class2 = function (_PureComponent) {
  (0, _inherits3.default)(MyPlaylistTrackPopover, _PureComponent);

  function MyPlaylistTrackPopover() {
    (0, _classCallCheck3.default)(this, MyPlaylistTrackPopover);
    return (0, _possibleConstructorReturn3.default)(this, (MyPlaylistTrackPopover.__proto__ || (0, _getPrototypeOf2.default)(MyPlaylistTrackPopover)).apply(this, arguments));
  }

  (0, _createClass3.default)(MyPlaylistTrackPopover, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          id = _props.id,
          onInit = _props.onInit,
          onDelete = _props.onDelete;


      return _react2.default.createElement(
        _PopoverMenu2.default,
        { id: id, ref: onInit },
        _react2.default.createElement(_PopoverMenuItem2.default, { onClick: onDelete, title: t('Delete'), iconClass: 'icon-delete' })
      );
    }
  }]);
  return MyPlaylistTrackPopover;
}(_react.PureComponent), _class2.propTypes = {
  id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
  onDelete: _propTypes2.default.func,
  onInit: _propTypes2.default.func,
  t: _propTypes2.default.func
}, _temp)) || _class);
exports.default = MyPlaylistTrackPopover;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/MyPlaylist/components/MyPlaylistTrackPopover.js
// module id = 2167
// module chunks = 1